import { ConsentType } from 'src/clientConfiguration';
import { Milliseconds } from 'src/types';
import { ClientDataType } from './types';
import { ConsentBlockingBehaviour } from 'src/clientConfiguration/types';
import { DEFAULT_DATA_FILE_CONFIGURATION } from 'src/clientConfiguration/constants';

/**
 * @readonly
 * @enum {string} an Enum containing keys for Kameleoon SDK related data stored on storage
 * */
export enum KameleoonStorageKey {
  ClientData = 'kameleoonClientData',
  TargetingData = 'kameleoonTargetingData',
  TrackingData = 'kameleoonTrackingData',
  VariationData = 'kameleoonVariationData',
  VisitorCode = 'kameleoonVisitorCode',
  ConsentData = 'kameleoonConsentData',
  DataInfo = 'kameleoonDataInfo',
  KameleoonSimulationFFData = 'kameleoonSimulationFFData',
  ForcedFeatureVariation = 'kameleoonForcedFeatureVariation',
  ForcedExperimentVariation = 'kameleoonForcedExperimentVariation',
}

export const DEFAULT_CLIENT_CONFIGURATION: ClientDataType = {
  data: DEFAULT_DATA_FILE_CONFIGURATION,
  lastUpdate: '',
};

// --- Note ---
// Not a real visit duration, rather a guaranteed minimum time
export const VISIT_DURATION = 29 * Milliseconds.Minute;
